import { AppBuilderPromptInput } from 'breeze-builder-lib';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { SliderSection } from '../../components/SliderSection';
import { useAppContext } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import { useGates } from '../../hooks/useGates';
import { useGetSuggestionSections } from '../../hooks/useGetSuggestionSections';
import { useProductTypeSearchParam, useProductTypes } from '../../hooks/useProductTypeSearchParams';
import { isQa } from '../../utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FEEDBACK_SURVEY_URL = {
  qa: 'https://survey.hsformsqa.com/1Gts5cjB_RaW5RhIsfGulZw1nzr9v',
  prod: 'https://survey.hsforms.com/1aOqSsquRQYWUgs_20YLUMQ1h'
};
function getFeedbackSurveyUrl(email) {
  const baseUrl = isQa() ? FEEDBACK_SURVEY_URL.qa : FEEDBACK_SURVEY_URL.prod;
  return email ? `${baseUrl}?email=${encodeURIComponent(email)}` : baseUrl;
}
export function NoResults() {
  var _auth$user, _data$result;
  const params = useSearchParams();
  const search = params.get('search');
  const productType = useProductTypeSearchParam();
  const productTypes = useProductTypes();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const auth = useAuth();
  const userEmail = (_auth$user = auth.user) === null || _auth$user === void 0 ? void 0 : _auth$user.email;
  const appContext = useAppContext();
  const {
    builderWorker
  } = useGates();
  const shouldShowAppBuilder = builderWorker && appContext === 'app' && productTypes.includes('APP');
  trackMarketplaceEvent(getMarketplaceInteractionEvent({
    action: 'search dead end reached',
    search,
    type: productType
  }));
  const handleFeedbackLinkClick = () => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'feedback survey link clicked'
    }));
  };
  const handleAppBuilderSubmit = prompt => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'app builder prompt submitted',
      search: prompt
    }));
  };
  const {
    data
  } = useGetSuggestionSections(Object.assign({
    maximumSections: 1,
    minimumSectionCardCount: 3
  }, productType ? {
    productTypes: [productType]
  } : {}));
  const sections = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.sections;
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    alignItems: "start",
    gap: "1200",
    marginBlockStart: "800",
    marginInlineEnd: "400",
    children: [/*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      alignItems: "start",
      gap: "600",
      alignSelf: "stretch",
      children: [/*#__PURE__*/_jsxs(View, {
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-400",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.noResults.title"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.noResults.description"
          })
        }), /*#__PURE__*/_jsxs(Text, {
          typography: "body-100",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.noResults.feedbackText"
          }), ' ', /*#__PURE__*/_jsx(Link, {
            href: getFeedbackSurveyUrl(userEmail),
            external: true,
            onClick: handleFeedbackLinkClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.searchResults.noResults.feedbackLinkText"
            })
          }), "."]
        })]
      }), shouldShowAppBuilder && /*#__PURE__*/_jsxs(View, {
        alignSelf: "stretch",
        maxInlineSize: "600px",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.searchResults.noResults.appBuilderHeading"
          })
        }), /*#__PURE__*/_jsx(AppBuilderPromptInput, {
          onSubmit: handleAppBuilderSubmit,
          placeholder: unescapedText('marketplaceStorefront.searchResults.noResults.appBuilderPlaceholder')
        })]
      })]
    }), sections === null || sections === void 0 ? void 0 : sections.map((section, index) => {
      var _section$cards, _section$contexts;
      return /*#__PURE__*/_jsx(SliderSection, {
        cards: (_section$cards = section.cards) !== null && _section$cards !== void 0 ? _section$cards : [],
        context: (_section$contexts = section.contexts) === null || _section$contexts === void 0 ? void 0 : _section$contexts[0],
        sectionIndex: index,
        sectionType: section.sectionType,
        title: section.title
      }, index);
    })]
  });
}